import { HttpClient } from '@angular/common/http';
import { AfterViewInit, Component, Injectable, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ChartComponent } from 'ng-apexcharts';
import { Observable, of, Subscription } from 'rxjs';

declare var $: any; // declaring jquery in this way solved the problem
declare var KTUtil;
declare var HOST_URL;

import { DatePipe } from '@angular/common';

import { Directive, EventEmitter, Input, Output, QueryList, ViewChildren } from '@angular/core';




export type SortColumn = keyof any | '';
export type SortDirection = 'asc' | 'desc' | '';
const rotate: { [key: string]: SortDirection } = { 'asc': 'desc', 'desc': '', '': 'asc' };

const compare = (v1: string | number, v2: string | number) => v1 < v2 ? -1 : v1 > v2 ? 1 : 0;

export interface SortEvent {
	column: SortColumn;
	direction: SortDirection;
}

@Directive({
	selector: 'th[sortable]',
	host: {
		'[class.asc]': 'direction === "asc"',
		'[class.desc]': 'direction === "desc"',
		'(click)': 'rotate()'
	}
})
export class NgbdSortableHeader {

	@Input() sortable: SortColumn = '';
	@Input() direction: SortDirection = '';
	@Output() sort = new EventEmitter<SortEvent>();

	rotate() {
		this.direction = rotate[this.direction];
		this.sort.emit({ column: this.sortable, direction: this.direction });
	}
}


export interface Reports {
	title: string;
	APIUrl: string;
	datafilter?: any;
	collection: string;
	type: string;
	series: any;
	field: any;
	data: any;
	filter: any;
	xaxis?: any;
	stacked?: boolean;
	isfilter?: boolean;
	zoom?: boolean;
	size?: number;
	//wtitle?:any;
	goal?:number;
	width?:any;
	bgcolor?:any;
};

@Injectable()
export class ReportService {
	private appmod: string;

	constructor(protected http: HttpClient) { }

	public Report(url: string, type?: string, filter?: any): Observable<any> {
		this.appmod = url;
		//console.log(this.appmod);
		//console.log(type);
		//console.log(filter);
		if (filter == undefined) {
			if (type != undefined)
				return this.http.get<any>(this.appmod, { headers: { "Content-Type": "application/json" }, params: { type } });
			else
				return this.http.get<any>(this.appmod, { headers: { "Content-Type": "application/json" }, params: { type: "main" } });
		}
		else {
			if (type != undefined)
				return this.http.get<any>(this.appmod, { headers: { "Content-Type": "application/json" }, params: { type, filter: JSON.stringify(filter) } });
			else
				return this.http.get<any>(this.appmod, { headers: { "Content-Type": "application/json" }, params: { type: "main", filter: JSON.stringify(filter) } });
		}
	}
}

@Component({
	selector: 'Report',
	templateUrl: './report.component.html',
	styleUrls: ['./report.component.css']
})

export class ReportComponent implements OnInit, AfterViewInit, OnDestroy {
	@Input() title?: string;
	
	@Input() APIUrl: string;
	@Input() datafilter?: string;
	@Input() collection: string;
	@Input() type: string;
	@Input() series: any;
	@Input() field: any;
	@Input() data: any;
	@Input() filter: any;
	@Input() xaxis: any;
	@Input() stacked?: boolean = false;
	@Input() isfilter: boolean;
	@Input() zoom?: boolean = false;
	@Input() size?: number = 200;
	@Input() goal?: number = 0;

	//value: '98', per: '65.5%'  icon: 'fa fa-arrow-up fa-2x'
	icon:string="fa fa-arrow-up fa-2x";
	value:number=0;
	lastvalue:number=0;
	per:number=0;
	//displayvalue:string="";
	displayvalue:any;
	width:any="0%";
	@Input() bgcolor?:any;
	//@Input() wtitle?:any;

	@Input() widgets:boolean;
	public widgetstatus: boolean = false;
	
	private sub: Subscription;
	public tablestatus: boolean = false;
	public reportstatus: boolean = false;
	public reportdata: any;
	collectionSize: any;
	x: any;

	@ViewChild("chart") chart: ChartComponent;
	constructor(private report: ReportService, private dt: DatePipe) { }
	page = 1;
	public pageSize = 25;
	@ViewChildren(NgbdSortableHeader) headers1: QueryList<NgbdSortableHeader>;

	onSort({ column, direction }: SortEvent) {
		// resetting other headers
		this.headers1.forEach(header => {
			if (header.sortable !== column) {
				header.direction = '';
			}
		});

		// sorting countries
		if (direction === '' || column === '') {
			this.x = this.x;
		} else {
			this.x = [...this.x].sort((a, b) => {
				const res = compare(a[column], b[column]);
				return direction === 'asc' ? res : -res;
			});
		}
	}

	OnDataChange(event: any) {
		// console.log(event.target.value);
		// Object.entries(this.filter).forEach(ele => {
		// 	this.filter[ele[0]] = event.target.value;
		// });
		// this.reportstatus = false;
		// if (this.type == "bar" || this.type == "area" || this.type == "line") {
		// 	this.sub = this.report.Report(this.APIUrl + "mixed", this.collection, { zoom: this.zoom, stacked: this.stacked, gtype: this.type, series: this.series, fields: this.field, data: this.data, filter: this.filter, xaxis: this.xaxis, size: this.size }).subscribe(res => {
		// 		console.log(res);
		// 		this.reportdata = res;
		// 		//this.reportdata.xaxis=tmp;
		// 		this.reportstatus = true;
		// 	});
		// }

		console.log(event.target.value);
		Object.entries(this.filter).forEach(ele => {
			this.filter[ele[0]] = event.target.value;
		});
		this.reportstatus = false;
		if (this.type == "bar" || this.type == "area" || this.type == "line") {
			
			this.sub = this.report.Report(this.APIUrl + "mixed", this.collection, { zoom: this.zoom, stacked: this.stacked, gtype: this.type, series: this.series, fields: this.field, data: this.data, filter: this.filter, xaxis: this.xaxis, size: this.size }).subscribe(res => {
				console.log(res);
				this.reportdata = res;
				this.reportstatus = true;
			});
		}

		if (this.type == "donut" || this.type == "pie" || this.type == "radialBar") {
			this.sub = this.report.Report(this.APIUrl + "circular", this.collection, { zoom: this.zoom, stacked: this.stacked, gtype: this.type, series: this.series, fields: this.field, data: this.data, filter: this.filter, size: this.size }).subscribe(res => {
				console.log(res);
				this.reportdata = res;
				this.reportstatus = true;
				//console.log("testing");
			});
			
		}

		if (this.type == "table") {
			this.sub = this.report.Report(this.APIUrl + "data", this.collection, { series: this.series, fields: this.field, data: this.data, filter: this.filter }).subscribe(res => {
				console.log(res);
				this.reportdata = res;
				this.collectionSize = this.reportdata.length;
				this.x = this.reportdata
					.map((x, i) => ({ id: i + 1, ...x })).slice((this.page - 1) * this.pageSize, (this.page - 1) * this.pageSize + this.pageSize);
				this.tablestatus = true;
			});
		}
		if (this.type == "widget") 
		{			
			this.sub = this.report.Report(this.APIUrl + "data", this.collection, { series: this.series, fields: this.field, data: this.data, filter: this.filter }).subscribe(res => {
				console.log(res);
				this.reportdata = res;
				console.log("Widget Testing", this.reportdata);
				this.widgetstatus = true;
			});
		}
		if (this.type == "notification") {
			this.sub = this.report.Report(this.APIUrl + "data", this.collection, { series: this.series, fields: this.field, data: this.data, filter: this.filter }).subscribe(res => {
				console.log(res);
				this.reportdata = res;
				this.tablestatus = true;
			});
		}

		if (this.type == "conversation") {
			this.sub = this.report.Report(this.APIUrl + "data", this.collection, { series: this.series, fields: this.field, data: this.data, filter: this.filter }).subscribe(res => {
				console.log(res);
				this.reportdata = res;
				this.tablestatus = true;
			});
		}

	}

	ngOnInit() {
		console.log("hello",this.bgcolor);
	}

	ngAfterViewInit() {

		// if (this.type == "bar" || this.type == "area" || this.type == "line") {
		// 	this.sub = this.report.Report(this.APIUrl + "mixed", this.collection, { zoom: this.zoom, stacked: this.stacked, gtype: this.type, series: this.series, fields: this.field, data: this.data, filter: this.filter, xaxis: this.xaxis, size: this.size }).subscribe(res => {
		// 		console.log(res);
		// 		let tmp=[];
		// 		let t:any=res.xaxis.categories;
		// 		t.forEach(element => {
		// 			tmp.push(this.dt.transform(element, "yyyy-MM")) //MMMM//
		// 		});
		// 		this.reportdata = res;
		// 		this.reportdata.xaxis.categories=tmp;
		// 		this.reportstatus = true;
		// 	});
		// }

		if (this.type == "bar" || this.type == "area" || this.type == "line") {
			this.sub = this.report.Report(this.APIUrl + "mixed", this.collection, { zoom: this.zoom, stacked: this.stacked, gtype: this.type, series: this.series, fields: this.field, data: this.data, filter: this.filter, xaxis: this.xaxis, size: this.size }).subscribe(res => {
				console.log("report data",res);
				this.reportdata = res;
				this.reportstatus = true;
			});
		}

		if (this.type == "donut" || this.type == "pie" || this.type == "radialBar") {
			this.sub = this.report.Report(this.APIUrl + "circular", this.collection, { zoom: this.zoom, stacked: this.stacked, gtype: this.type, series: this.series, fields: this.field, data: this.data, filter: this.filter, size: this.size }).subscribe(res => {
				console.log(res);
				this.reportdata = res;
				this.reportstatus = true;
			});
		}

		if (this.type == "table") {
			this.sub = this.report.Report(this.APIUrl + "data", this.collection, { series: this.series, fields: this.field, data: this.data, filter: this.filter }).subscribe(res => {
				console.log(res);
				this.reportdata = res;
				this.collectionSize = this.reportdata.length;
				this.x = this.reportdata.map((x, i) => ({ id: i + 1, ...x })).slice((this.page - 1) * this.pageSize, (this.page - 1) * this.pageSize + this.pageSize);
				this.tablestatus = true;
			});
		}

		if (this.type == "widget") 
		{			
			this.sub = this.report.Report(this.APIUrl + "data", this.collection, { series: this.series, fields: this.field, data: this.data, filter: this.filter }).subscribe(res => {
				console.log(res);
				let curmonth=this.dt.transform(Date().toString(),"yyyy-MM");
				//console.log(curmonth);
				// let lastmonth=this.dt.transform(Date.now()-30*24*60*60*1000,"yyyy-MM");
				// console.log(curmonth+"     "+lastmonth+"     "+this.series[0]["series"]);
				res.forEach(tmp => {
					//console.log(tmp);
					if(tmp[this.series[0]["series"]]==curmonth)
					{
						let ctmp=0;
						Object.entries(tmp).forEach((val:any)=>{
							if(ctmp>1)
							{
								console.log(ctmp+"  "+val);
								this.value+=parseInt(val[1]);
								console.log(this.value);
							}
							ctmp++;
						});
					}

					// if(tmp[this.series[0]["series"]]==lastmonth)
					// {
					// 	let ctmp=0;
					// 	Object.entries(tmp).forEach((val:any)=>{
					// 		if(ctmp>1){
					// 			console.log(ctmp+"  "+val);
					// 			this.lastvalue+=parseInt(val[1]);
					// 			console.log(this.lastvalue);
					// 		}
					// 		ctmp++;
					// 	});
					// }

					// if(this.lastvalue>this.value)
					// 	this.icon="fa fa-arrow-down fa-2x";
					// else
					// 	this.icon="fa fa-arrow-up fa-2x";
					
					//this.displayvalue=this.value+"/"+this.lastvalue;
					this.displayvalue=this.value;
					console.log("displayvalue",this.displayvalue)
					// console.log(this.goal);
					this.per=Math.ceil(this.value*100/this.goal);
					this.width=this.per+"%";
					console.log(this.width);
					this.widgetstatus = true;
				});
			});
		}

		if (this.type == "conversation") {
			this.sub = this.report.Report(this.APIUrl + "data", this.collection, { series: this.series, fields: this.field, data: this.data, filter: this.filter }).subscribe(res => {
				console.log(res);
				this.reportdata = res;
				this.tablestatus = true;
			});
		}
	}

	refreshCountries() {
		this.x = this.reportdata
			.slice((this.page - 1) * this.pageSize, (this.page - 1) * this.pageSize + this.pageSize);

	}

	ngOnDestroy() {
		if(this.sub!=undefined)
			this.sub.unsubscribe();
	}
}